/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Faq_Q5Inputs */

const en_formatter_faq_q5 = /** @type {(inputs: Formatter_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I format JSON with comments or trailing commas?`)
};

const ko_formatter_faq_q5 = /** @type {(inputs: Formatter_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주석이나 후행 쉼표가 있는 JSON을 포맷할 수 있나요?`)
};

const ja_formatter_faq_q5 = /** @type {(inputs: Formatter_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コメントや末尾カンマのあるJSONをフォーマットできますか？`)
};

/**
* | output |
* | --- |
* | "Can I format JSON with comments or trailing commas?" |
*
* @param {Formatter_Faq_Q5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_faq_q5 = /** @type {((inputs?: Formatter_Faq_Q5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Faq_Q5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_faq_q5(inputs)
	if (locale === "ko") return ko_formatter_faq_q5(inputs)
	return ja_formatter_faq_q5(inputs)
});